import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import MUIButton from 'material-ui/Button'
import classNames from 'classnames'

const styles = theme => ({
  Button: {
    minHeight: 44,
    borderRadius: 5,
    boxSizing: 'border-box',
    padding: '12px 16px',
  },
  disabled: {
    background: theme.palette.grey[100] + '!important',
    color: theme.palette.border + '!important',
    border: 'solid 2px ' + theme.palette.border + '!important',
  },
  primary: {
    background: theme.palette.primary.main,
    color: '#FFF',
    '&:hover': {
      background: theme.palette.primary.light,
      color: '#FFF',
    },
  },
  secondary: {
    background: 'rgba(0,0,0,0)',
    color: theme.palette.primary.main,
    border: 'solid 2px ' + theme.palette.primary.main,
    '&:hover': {
      background: 'rgba(0,0,0,0)', // Overwrite default behavior
      color: theme.palette.primary.light,
    },
  },
})

const Button = ({classes, children, onClick, variant = 'primary', className, ...props}) => (
  <MUIButton
    {...props}
    variant="flat"
    onClick={onClick}
    className={classNames(
      classes.Button,
      {[classes.disabled]: props.disabled === true},
      {
        [classes.primary]: variant === 'primary',
        [classes.secondary]: variant === 'secondary',
      },
      className,
    )}
  >
    {children}
  </MUIButton>
)

Button.propTypes = {
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['primary', 'secondary']),
}

export default withStyles(styles, {withTheme: true})(Button)



// WEBPACK FOOTER //
// ./src/components/button.jsx